import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import {handleCaptcha, initCaptcha, resetCaptcha} from '../../utils/captcha';
import {areAllPropertiesEmpty} from "../../utils/helpers";
import {reportJobAlertSubscriptionEvent} from "../../utils/analytics";
import {logErrorMessage} from '../../utils/errors';
import trans from "../../utils/trans";
import showInfoModal from "../../utils/info-modal";
import * as notification from '../../components/notifications';

class AlertSubscription {
  constructor(section) {
    this.section = section;
    this.alertSubscriptionForm = $(".inline-alert-subscription-1", this.section);
    this.idAttributePrefix = this.section.attr('id') + '-';
    this.captchaId = this.idAttributePrefix + 'captcha-container';

    this._initCaptcha();
  }

  _initCaptcha() {
    initCaptcha(() => {
      this.alertSubscription();
    }, this.captchaId);

    this.alertSubscriptionForm.submit(handleCaptcha(
      (e) => {
        this.alertSubscription();

        return false;
      }, this.captchaId
    ));
  }

  async alertSubscription() {
    const data = this.getAlertSubscriptionData();

    $('.btn-submit', this.alertSubscriptionForm).loading();

    try {
      let response;
      response = await axios.post("/api/jobs/subscribe", data);

      resetFormErrors(this.alertSubscriptionForm);

      this.createAlertSubscriptionStatusEvent(response.data.message);

      reportJobAlertSubscriptionEvent();

      this.alertSubscriptionForm.trigger('reset');
      this.alertSubscriptionForm.find('select').selectpicker('refresh');

      $('.btn-submit', this.alertSubscriptionForm).loading(false);
    } catch (e) {
      console.log('error', e);

      $('.btn-submit', this.alertSubscriptionForm).loading(false);

      let response = e.response;
      let errors = response.data.errors;
      response.data.errors = {};

      if (typeof errors.message !== 'undefined') {
        notification.danger(errors.message);
      } else {
        if (typeof errors.email !== 'undefined') {
          response.data.errors.email = errors.email;
        } else {
          response.data.errors.email = ['Something went wrong, please reload this page and try again!'];
          logErrorMessage('Alert Subscribe: Unexpected error response received', e);
        }

        if (response.data.errors.email) {
          showFormErrors(this.alertSubscriptionForm, response);
        }
      }
    }

    resetCaptcha(this.captchaId);
  }

  getAlertSubscriptionData() {
    const data = getFormData(this.alertSubscriptionForm);
    let alertConditions = JSON.parse($(`#${this.idAttributePrefix}job-filters`).val());

    // Ensure alertConditions is an object, not an array
    if (Array.isArray(alertConditions)) {
      alertConditions = {};
    }

    if (data.hasOwnProperty('category')) {
      alertConditions.category = data.category ? {
        'id' : +data.category
      } : null;
    }

    delete data['category'];

    if (!areAllPropertiesEmpty(alertConditions)) {
      data.alert_condition = alertConditions;
    }

    return data;
  }

  createAlertSubscriptionStatusEvent(message) {
    const statusBox = $(`<div>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2 text-success" viewBox="0 0 16 16">
          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
      </svg>
      ${message}
    </div>`);

    showInfoModal({
      title: trans('alert_subscription.success.title'),
      message: statusBox,
    });
  }
}

const initPage = () => {
  const jbSections = $('.jb-section');

  jbSections.each(function (index) {
    if (!$('.inline-alert-subscription-1', this).length) {
      return;
    }

    const sectionContainer = $(this).parent();
    new AlertSubscription(sectionContainer)
  })
};

$(initPage);
